import { createAction, props } from '@ngrx/store';
import { ILoaderActionPayload } from '../models/loader.model';
import { CronJobControllerFind$Params } from '../../../api/functions';
import { CronJobListResponse } from '../../../api/models';

export const cronJobActions = {
  // list
  loadCronJobList: createAction('load/cron-job/load', props<CronJobControllerFind$Params>()),
  loadCronJobListDone: createAction(
    'load/cron-job/done',
    props<{
      state: ILoaderActionPayload;
      data?: CronJobListResponse;
      request?: CronJobControllerFind$Params;
    }>(),
  ),
  loadCronJobListSetState: createAction('cron-job/state', props<{ state: ILoaderActionPayload }>()),
  //   loadOneCluster: createAction('load/cron-job/loadOne', props<$Params>()),
  //   loadOneCronJobDone: createAction(
  //     'load/cron-job/doneOne',
  //     props<{
  //       state: ILoaderActionPayload;
  //       data?: ;
  //       request?: $Params;
  //     }>(),
  //   ),
  //   loadOneCronJobSetState: createAction('cron-job/loadOne/state', props<{ state: ILoaderActionPayload }>()),
};
